export default "__VITE_ASSET__DhJuoYSh__"